import { useState } from "react";
import { MenuContext } from "./MenuContext";

interface Props {
    children: React.ReactNode
}

export const MenuProvider = ({ children }: Props) => {
    const [open, setOpen] = useState(true);
    const toggleDrawer = () => {
        setOpen(!open);
    };

    return (
        <MenuContext.Provider value={{ open, setOpen: toggleDrawer }}>
            {children}
        </MenuContext.Provider>
    )
}